<div class="app-container">
  <page-header [title]="'checkouts'" [icon]="'far-money-bill'">
    <ng-container class="header-button">
      @if (canCreate) {
        <btn
          [routerLink]="['/checkout']"
          [classes]="['btn-first', 'float-right']"
          [icon]="'far-plus'"
          [label]="'checkout.btn.create'"
          [title]="'checkout.btn.create' | translate"
          [dataCyAttribute]="'go-checkout'"
        ></btn>
      }
    </ng-container>
  </page-header>

  @if (!!filters) {
    <section class="content">
      <app-filter-form
        [filters]="queryFilters()"
        [filtersForExport]="queryFilters()"
        [entity]="'checkouts'"
        (onSubmit)="queryCheckouts.refetch()"
        (onClearClick)="clearFilters()"
        [isFilterInvisible]="true"
        [totalItems]="totalItems()"
      >
        <form-row-input
          [model]="filters().name"
          (modelChange)="onNameFilterChange($event)"
          (keydown.enter)="queryCheckouts.refetch()"
          [icon]="'far-list'"
          [label]="'checkouts.name'"
          [dataCyAttribute]="'checkout-name-filter'"
        ></form-row-input>
      </app-filter-form>
      <app-base-listing
        [listName]="'checkouts'"
        [query]="queryCheckouts"
        [columns]="listingColumns"
        [selectedColumns]="listingColumns"
        [sortProp]="sortProp"
        [sortDir]="sortDir"
      ></app-base-listing>
    </section>
  }
</div>
